// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// Import
// --------------------------------------------------------------- //
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import { EaselPlugin } from "gsap/EaselPlugin";
import barba from '@barba/core';

//import frontNewsTab from './front-page.js';
import frontScrollBackground from './front-page-scroll.js';
import siteMenu from './site-menu.js';
import dropDownMenu from './dropdown-menu.js';
import linkSyncNone from './link-stync-none.js';
import swiper from './swiper.js';
import career from './career.js';



// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// meta タグの情報の書き換えを行う
	// --------------------------------------------------------------- //

	const replaceHeadTags = target => {
		const head = document.head;
		const targetHead = target.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
		const newPageHead = document.createElement('head');
		newPageHead.innerHTML = targetHead;
		const removeHeadTags = [
			"meta[name='keywords']",
			"meta[name='description']",
			"meta[property^='fb']",
			"meta[property^='og']",
			"meta[name^='twitter']",
			"meta[name='robots']",
			'meta[itemprop]',
			'link[itemprop]',
			"link[rel='prev']",
			"link[rel='next']",
			"link[rel='canonical']",
		].join(',');
		const headTags = [...head.querySelectorAll(removeHeadTags)];
		headTags.forEach(item => {
			head.removeChild(item);
		} );
		const newHeadTags = [...newPageHead.querySelectorAll(removeHeadTags)];
		newHeadTags.forEach(item => {
			head.appendChild(item);
		} );
	}


	// 同じ URL の場合ページ遷移をさせない
	// --------------------------------------------------------------- //
	const eventDelete = e => {
		if (e.currentTarget.href === window.location.href) {
			e.preventDefault();
			e.stopPropagation();
		return;
		}
	}

	const links = [...document.querySelectorAll('a[href]')];
	links.forEach(link => {
		link.addEventListener('click', e => {
			eventDelete(e);
		}, false)
	});



	// GSAP の設定
	// --------------------------------------------------------------- //

	gsap.config( {
		nullTargetWarn: false,
	} );



	// ページ読み込み時のジオメトリ
	// --------------------------------------------------------------- //

	gsap.fromTo(
		"#bg-container",
		{
			opacity: 0,
		}, {
			opacity: 1,
			//ease: 'power1.out',
			ease: 'Linear.easeNone',
			duration: 4,
			delay: 0,
		}
	);



	// トップページのタイポグラフィ
	// --------------------------------------------------------------- //

	function frontCopyAnimation() {
		gsap.fromTo(
			"#front-main-copy-1 span",
			{
				opacity: 0,
				y: 10,
			}, {
				opacity: 1,
				y: 0,
				ease: 'Linear.easeNone',
				stagger: 0.1,
				duration: .6,
				delay: 0,
			}
		);
		gsap.fromTo(
			"#front-main-copy-2 span",
			{
				opacity: 0,
				y: 10,
			}, {
				opacity: 1,
				y: 0,
				ease: 'Linear.easeNone',
				stagger: 0.1,
				duration: .4,
				delay: .5,
			}
		);
	}
	frontCopyAnimation();


	// ページヘッダーのタイポグラフィ
	// --------------------------------------------------------------- //

	function pageTitleAnimation() {
		gsap.fromTo(
			"#js-page-title span",
			{
				opacity: 0,
				y: 15,
				x: 8,
			}, {
				opacity: 1,
				y: 0,
				x: 0,
				ease: 'Linear.easeNone',
				stagger: 0.15,
				duration: .6,
				delay: 0,
			}
		);
	}
	pageTitleAnimation();

	function pageSubTitleAnimation() {
		gsap.fromTo(
			"#js-page-sub-title",
			{
				opacity: 0,
				y: 20,
			}, {
				opacity: 1,
				y: 0,
				ease: 'Linear.easeNone',
				delay: .8,
			}
		);
	}
	pageSubTitleAnimation();



	// パンくずアニメーション
	// --------------------------------------------------------------- //

	function breadcrumbAnimation() {
		gsap.fromTo(
			"#js-breadcrumb-animation",
			{
				opacity: 0,
				y: 20,
			}, {
				opacity: 1,
				y: 0,
				ease: 'Linear.easeNone',
				delay: .8,
			}
		);
	}
	breadcrumbAnimation();



	// 汎用的なアニメーション
	// --------------------------------------------------------------- //

	function scrollGeneAnimation() {
		let scrollAnimeElmnts = gsap.utils.toArray('.js-scroll-animation');
		scrollAnimeElmnts.forEach((scrollAnimeElmnt) => {
			gsap.fromTo(
				scrollAnimeElmnt,
				{
					y: 50,
					autoAlpha: 0,
				},
				{
					y: 0,
					autoAlpha: 1,
					ease: 'Linear.easeNone',
					duration: .8,
					scrollTrigger: {
						trigger: scrollAnimeElmnt,
						start: "top center+=25%",
						//markers: true
					},
				}
			);
		});
	}
	scrollGeneAnimation();



	// TOPページのアニメーション
	// --------------------------------------------------------------- //

	function scrollFrontPageAnimation() {
//		const aboutTitleItems = document.querySelectorAll('.front-entry-wrapper');
//		aboutTitleItems.forEach((aboutTitleItem) => {
//			ScrollTrigger.create( {
//				trigger: aboutTitleItem,
//				start: "top-=0px center",
//				toggleClass: {
//					targets: '#bg-container-cover',
//					className: "is-scroll",
//				},
//				once: true,
//			} );
//		});

		gsap.fromTo('.front-business-header__background', {
			x: -80,
			autoAlpha: 0,
		}, {
			x: 0,
			ease: 'Linear.easeNone',
			duration: .4,
			autoAlpha: 1,
			scrollTrigger: {
				trigger: ".front-business-header",
				start: "top center+=20%",
			},
		});

		gsap.to('.front-business__background', {
			scrollTrigger: {
				trigger: ".front-business-header",
				start: "top center+=30%",
				toggleClass: {
					targets: '.front-business__background',
					className: 'is-active',
				},
				once: true,
			},
		});

		let scrollAnimeElmnts = gsap.utils.toArray('.business-item');
		scrollAnimeElmnts.forEach((scrollAnimeElmnt) => {
			gsap.fromTo(
				scrollAnimeElmnt,
				{
					x: -30,
					autoAlpha: 0,
				},
				{
					x: 0,
					autoAlpha: 1,
					ease: 'Linear.easeNone',
					duration: .8,
					scrollTrigger: {
						trigger: scrollAnimeElmnt,
						start: "top center+=25%",
						//markers: true
					},
				}
			);
		});



	}
	scrollFrontPageAnimation();




	// 企業情報の見出しアニメーション
	// --------------------------------------------------------------- //

	function scrollAboutTitleAnimation() {
		const aboutTitleItems = document.querySelectorAll('.js-about-headline .page-about-headline__text');
		aboutTitleItems.forEach((aboutTitleItem) => {
			gsap.fromTo(
				aboutTitleItem,
				{
					autoAlpha: 0,
				},
				{
					autoAlpha: 1,
					ease: 'power1.out',
					duration: .1,
					delay: .6,
					scrollTrigger: {
						trigger: aboutTitleItem,
						start: "top center+=25%",
						//markers: true
					},
				}
			);
		});

		const aboutTitleCoverItems = document.querySelectorAll('.js-about-headline .page-about-headline__cover');
		aboutTitleCoverItems.forEach((aboutTitleCoverItem) => {
			gsap.fromTo(
				aboutTitleCoverItem,
				{
					width: 0,
				},
				{
					width: '100%',
					ease: 'power1.out',
					duration: .3,
					scrollTrigger: {
						trigger: aboutTitleCoverItem,
						start: "top center+=25%",
						//markers: true
					},
				}
			);
			gsap.to(
				aboutTitleCoverItem,
				{
					x: '200%',
					ease: 'power1.in',
					duration: .4,
					delay: .6,
					scrollTrigger: {
						trigger: aboutTitleCoverItem,
						start: "top center+=25%",
						//markers: true
					},
				}
			);

		});


	}
	scrollAboutTitleAnimation();



	// 遅延用 引数の分だけ処理を遅らせる
	function delay (n) {
		n = n || 2000;
		return new Promise((done) => {
			setTimeout(() => {
				done();
			}, n);
		} );
	}

	// ページを離れる時の動作の関数
	function leaveAnimation() {
		const tl = gsap.timeline();
		//tl.to('.page-container', {
		tl.to('.site-main', {
			duration: .5,
			opacity: 0,
			ease: 'Linear.easeNone'
		});
	}

	// ページに入った時の動作の関数
	function enterAnimation() {
		const tl = gsap.timeline();
		//tl.from('.page-container', {
		tl.from('.site-main', {
			duration: 2,
			opacity: 0,
			ease: 'Linear.easeNone'
		});

	}

	barba.init( {
		sync: true,
		transitions: [
			{
				async leave (data) {
					const done = this.async();
					leaveAnimation();
					//await delay(200);
					done();
				},
				beforeEnter ({ next }) {
					const scrollElem = document.scrollingElement || document.documentElement
					scrollElem.scrollTop = 0;
				},
				async enter (data) {
					//await delay(200);

					enterAnimation();
				}
			}
		],

		views: [
			{
				namespace: 'front-page',
				beforeEnter (data) {
					document.querySelector('#bg-container-cover').classList.add('is-front-page');
				},
				afterLeave (data) {
					document.querySelector('#bg-container-cover').classList.remove('is-front-page');
				}
			},
			{
				namespace: 'page',
				beforeEnter (data) {
					document.querySelector('#bg-container-cover').classList.add('is-page');
				},
				afterLeave (data) {
					document.querySelector('#bg-container-cover').classList.remove('is-page');
				}
			},
			{
				namespace: 'hidden',
				beforeEnter (data) {
					document.querySelector('#bg-container-cover').classList.add('is-hidden');
				},
				afterLeave (data) {
					document.querySelector('#bg-container-cover').classList.remove('is-hidden');
				}
			},
			{
				namespace: 'lab',
				beforeEnter (data) {
					document.querySelector('#bg-container-cover').classList.add('is-lab');
				},
				afterLeave (data) {
					document.querySelector('#bg-container-cover').classList.remove('is-lab');
				}
			},
		],

		prevent: function (e) {
			// barbaのリンクとして実行させたくない場合の処理
			if ( e.el.classList.contains('ab-item') || e.el.classList.contains('js-sync-none') || e.el.closest('.js-sync-none') || e.el.closest('.is-style-sync-none') ) {
				return true;
			}
//			if ( e.el.querySelectorAll('.js-sync-none a') ) {
//				return true;
//			}

		}
	} );


	// meta タグの情報の書き換えを行う
	// --------------------------------------------------------------- //

	barba.hooks.beforeEnter(({ next }) => {
		replaceHeadTags(next);

	} );

	barba.hooks.after(() => {
		frontCopyAnimation();
		pageTitleAnimation();
		pageSubTitleAnimation();
		breadcrumbAnimation();

		//frontNewsTab();
		frontScrollBackground();
		siteMenu();
		dropDownMenu();
		linkSyncNone();
		swiper();
		career();

		scrollGeneAnimation();
		scrollFrontPageAnimation();
		scrollAboutTitleAnimation();
	});


} );

